/**
 * #1071 — the line the Spread/Total board stored for a game: the trader's
 * remembered pick (`spreadTotalLineMemory`, #823), else the default the board
 * seeded (`spreadTotalLineDefaults`). The board seeds from it, and Game Detail
 * opens on it, so a game the board shows on +4.5 opens on +4.5 there too.
 *
 * Its own module because the board already imports from Game Detail.
 */
import { rememberedSpreadTotalLine } from '@/stores/spreadTotalLineMemory';
import { spreadTotalDefault } from '@/stores/spreadTotalLineDefaults';

/** Index into `lines` of the stored pick, else the stored default; null when
 *  neither is stored or listed. */
export function storedSpreadTotalLineIndex<T>(
  scope: string | null,
  kind: 'spread' | 'total',
  event: string,
  lines: readonly T[],
  keyFor: (line: T) => string,
): number | null {
  for (const stored of [rememberedSpreadTotalLine(scope, kind, event), spreadTotalDefault(scope, kind, event)]) {
    if (stored == null) continue;
    const idx = lines.findIndex((line) => keyFor(line) === stored);
    if (idx >= 0) return idx;
  }
  return null;
}
